/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Listado from 'components/public/Listado/Listado';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { CompraBase } from 'utils/models/types';
import { titulosListadoComprasUsuario } from 'utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEspectaculos } from 'utils/redux/features/espectaculosSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { formatearFechaHoraParaListado, formatearFechaParaListado } from 'utils/utilities';
import { fetchComprasDeUsuario } from 'utils/redux/features/comprasDeUsuarioSlice';
import Spinner from 'components/public/Spinner/Spinner';

const MisCompras = () => {
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario = usuarioJSON && JSON.parse(usuarioJSON);
  const { comprasDeUsuario, loadingComprasDeUsuario, errorComprasDeusuario } = useSelector(
    (state: RootState) => state.comprasDeUsuario
  );

  const error401 = errorComprasDeusuario?.includes('permisos');
  const idUsuario = usuario.Id;
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchEspectaculos());
    dispatch(fetchComprasDeUsuario(idUsuario));
  }, [dispatch]);

  const comprasListado: CompraBase[] = comprasDeUsuario
    ? comprasDeUsuario.map((c: CompraBase) => {
        const descuento = (Number(c.MontoSinDescuento!) * Number(c.DescuentoAplicado!)) / 100;
        const totalPagar = Number(c.MontoSinDescuento!) - descuento;

        return {
          Id: c.Id,
          FechaInicioFuncion: c.FechaInicioFuncion && formatearFechaParaListado(c.FechaInicioFuncion.toString()),
          NombreEspectaculo: c.NombreEspectaculo,
          CantAsientos: c.CantAsientos,
          Precio: `$${totalPagar}`,
          Codigo: c.Codigo,
          DescuentoAplicado: `${c.DescuentoAplicado}%`,
          FechaCompra: c.FechaCompra && formatearFechaHoraParaListado(c.FechaCompra.toString()),
          Aprobada: true ? 'Sí' : 'No',
        };
      })
    : [];

  return loadingComprasDeUsuario ? (
    <Spinner />
  ) : errorComprasDeusuario ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={comprasListado}
      headCells={titulosListadoComprasUsuario}
      titulo="Mis compras"
      loading={loadingComprasDeUsuario}
    />
  );
};

export default MisCompras;
